// extracted by mini-css-extract-plugin
export default {"wrap":"VerifiedBadge_wrap__W4nV-","icon":"VerifiedBadge_icon__0IML-","label":"VerifiedBadge_label__KmWCz"};